<template>
    <div class="page-map">
        <map-loader
                class="the-map"
                src="maps/carte-royaumes.svg"
                :points="$store.state.pages"
        ></map-loader>
        <div class="texture">
            <table>
                <tr v-for="(line) in 20" :key="line">
                    <td v-for="(col) in 20" :key="col"></td>
                </tr>
            </table>
        </div>
    </div>
</template>

<script>
    import MapLoader from "../components/map/MapLoader";
    export default {
        name: "PageMap",
        components: {MapLoader},

    }

</script>

<style lang="less">
    .page-map{
        background-image: url("../assets/textures/bg-texture.jpg");
        display: flex;
        justify-content: center;
        align-items: center;
        .the-map{
            width: 25vw;
        }
        >ul{
            position: absolute;
            left: 3vw;
        }
        .texture{
            mix-blend-mode: overlay;
            background-image: url("../assets/textures/texture-transparente.png");
            pointer-events: none;
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            table{
                opacity: 0.3;
                border-collapse: collapse;
                td{
                    border: 0.5px solid #fff;
                    width: 5vw;
                    height: 5vw;
                }

            }
        }
    }

</style>